import _toConsumableArray from "/app/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _regeneratorRuntime from "/app/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import axios from "axios";
import { request } from "@/js/http/http_request";
import { defaultPagingChoices, listUserGroups } from "@/js/lists.ts";
import { hasRole, isAdminNotConsultant } from "@/js/http/auth.js";
import { cleanErrors, noErrors, filterVAutocomplete, ERROR_DATA, getErrorData, handleErrorData } from "@/js/forms.js";
import { getFullNameUser } from "@/js/user/user.js";
import pagingComponent from "@/components/paging/PagingComponent.vue";
import indexComponent from "@/components/paging/IndexComponent.vue";
import confirmationComponent from "@/components/modal/ConfirmationDialog.vue";
import ErrorModal from "@/components/modal/ErrorModal.vue";
import ScheduledCommissionsModal from "@/components/commission/ScheduledCommissionsModal.vue";
var defaultCommissionAddForm = {
  percentage_fee: 0,
  user_group: null,
  userId: null,
  consultantId: null,
  list_id_countries: [],
  list_id_wineries: [],
  list_id_wines: []
};
export default {
  name: "adminCommissionsList",
  components: {
    paging: pagingComponent,
    index: indexComponent,
    confirm: confirmationComponent,
    ErrorModal: ErrorModal,
    ScheduledCommissionsModal: ScheduledCommissionsModal
  },
  props: {
    loggedUserData: {
      type: Object,
      default: {}
    },
    target: String,
    role: String
  },
  data: function data() {
    return {
      COMMISSION_PERCENTAGE_CONSULTANT_HORECA: 5,
      canManage: false,
      familyFriendsCommission: 0,
      isModifyingFamilyFriendsCom: false,
      isUpdatingFamilyFriendsCom: false,
      gettingCommissionList: {
        isPending: true,
        items: [],
        totalNumber: 0,
        numberOfPages: 0,
        headers: [{
          text: "Country",
          align: "start",
          value: "countryName"
        }, {
          text: "Producer",
          value: "wineryName"
        }, {
          text: "Product",
          value: "wineName"
        }, {
          text: "Percentage fee (COGS)",
          value: "percentage_fee"
        }, {
          text: "Group / User / Consultant",
          value: "user_group_label"
        }, {
          text: "Actions",
          value: "actions",
          sortable: false
        }]
      },
      searchCriterias: {
        list_id_wines: [],
        list_id_wineries: [],
        list_id_countries: [],
        list_id_users: [],
        list_id_consultants: [],
        list_user_groups: [],
        paging: {
          limits: 24,
          currentPage: 0,
          askedPage: 0
        }
      },
      gettingUserList: {
        results: [],
        isPending: true
      },
      gettingConsultantList: {
        results: [],
        cancellationToken: null,
        isPending: true
      },
      gettingCountryList: {
        items: [],
        isPending: true
      },
      gettingWineList: {
        items: [],
        isPending: true
      },
      gettingProducerList: {
        items: [],
        isPending: true
      },
      dialogAddCommission: false,
      addingCommission: {
        isPending: false
      },
      commission: _objectSpread({}, defaultCommissionAddForm),
      errorLabels: {
        percentage_fee: "",
        user_group: ""
      },
      consultantError: "",
      errorMessages: {
        mandatory: "This field is required",
        criteria: {
          format: "The criterias are incorrect"
        },
        percentage_fee: {
          value: "The percentage fee must be between #min# and #max#%"
        }
      },
      isConsultantUsa: false,
      isConsultant: false,
      isScheduledCommissionsModalShown: false,
      scheduledFormValues: null,
      pagingLimitsChoices: defaultPagingChoices,
      ERROR_DATA: ERROR_DATA
    };
  },
  computed: {
    isEditingCommission: function isEditingCommission() {
      var _this$commission;
      return ((_this$commission = this.commission) === null || _this$commission === void 0 ? void 0 : _this$commission.id_commission) > 0;
    },
    isUserGroupRequired: function isUserGroupRequired() {
      return this.isConsultant;
    },
    percentageFeeMax: function percentageFeeMax() {
      return this.target == "consultant" ? 20 : 250;
    },
    percentageFeeMin: function percentageFeeMin() {
      return this.target == "consultant" ? 5 : -100;
    },
    derivedUserGroups: function derivedUserGroups() {
      return [{
        id: "HORECA",
        value: "Professionals"
      }, {
        id: "WHOLESALER",
        value: "Wholesalers"
      }, {
        id: "USER",
        value: "Individuals"
      }];
    },
    isCommissionAddingBlocked: function isCommissionAddingBlocked() {
      return this.isCommissionBlocked(this.commission);
    },
    hasResult: function hasResult() {
      return !this.gettingCommissionList.isPending && this.gettingCommissionList.totalNumber > 0;
    }
  },
  created: function created() {
    var _this2 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _this, response;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _this2.canManage = hasRole(_this2.role);
            if (!!_this2.$route.params && !!_this2.$route.params.searchCriterias) {
              _this2.searchCriterias = _objectSpread({}, _this2.$route.params.searchCriterias);
            }
            _this2.search();
            _this = _this2;
            if (_this.target == "consultant") {
              _this.isConsultant = true;
              _this.commission.user_group = "USER";
            }
            if (_this2.isConsultant) {
              _context.next = 12;
              break;
            }
            _context.next = 8;
            return request("/v1/commissions/family_friends", "GET", null, true, "api");
          case 8:
            response = _context.sent;
            _this2.familyFriendsCommission = response.data.value;
            _this2.getUserList();
            _this2.getConsultantList();
          case 12:
            _this2.getCountryList();
            _this2.getWineList();
            _this2.getProducerList();
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  watch: {
    "searchCriterias.list_id_wines": function searchCriteriasList_id_wines(newVal, oldVal) {
      this.search();
    },
    "searchCriterias.list_id_countries": function searchCriteriasList_id_countries(newVal, oldVal) {
      this.search();
    }
  },
  methods: {
    onClickFamilyFriends: function onClickFamilyFriends() {
      var _this3 = this;
      this.isModifyingFamilyFriendsCom = true;
      this.$nextTick(function () {
        _this3.$refs.familyFriendsTextFieldRef.focus();
      });
    },
    onModifyFamilyFriendsCommission: function onModifyFamilyFriendsCommission(e) {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var response;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this4.isModifyingFamilyFriendsCom = true;
              _this4.isUpdatingFamilyFriendsCom = true;
              _context2.next = 4;
              return request("/v1/commissions/family_friends", "POST", {
                rate: e.target.value
              }, true, "api");
            case 4:
              _context2.next = 6;
              return request("/v1/commissions/family_friends", "GET", null, true, "api");
            case 6:
              response = _context2.sent;
              _this4.familyFriendsCommission = response.data.value;
              _this4.isUpdatingFamilyFriendsCom = false;
              _this4.isModifyingFamilyFriendsCom = false;
              _this4.$toasted.show("Family & Friends commission saved.", {
                type: "success"
              });
            case 11:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))();
    },
    isCommissionBlocked: function isCommissionBlocked(commission) {
      var _commission$user_grou, _commission$user_grou2;
      return this.isConsultant && (((_commission$user_grou = commission.user_group) === null || _commission$user_grou === void 0 ? void 0 : _commission$user_grou.toUpperCase()) == "HORECA" || ((_commission$user_grou2 = commission.user_group) === null || _commission$user_grou2 === void 0 ? void 0 : _commission$user_grou2.toUpperCase()) == "WHOLESALER");
    },
    changePage: function changePage(askedPage) {
      if (askedPage >= 0 && askedPage <= this.gettingCommissionList.numberOfPages) {
        this.searchCriterias.paging.askedPage = askedPage;
        this.search();
      }
    },
    getUserList: function getUserList() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _this, response, values;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _this5.gettingUserList.results = [];
              _this5.gettingUserList.isPending = true;
              _this = _this5;
              _context3.next = 5;
              return request("/v1/third-party-users", "get", null, true, "api").catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of available users", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 5:
              response = _context3.sent;
              console.log(response);

              //Remove consultants and holdings of this list
              values = _toConsumableArray(response.data.value.filter(function (x) {
                return x.consultant_code == "" || x.consultant_code == null;
              }));
              values.forEach(function (user) {
                var _user$delivery_addres, _listUserGroups$find;
                var fullName = getFullNameUser(user) + " - " + user.delivery_address.country.iso_code + ((_user$delivery_addres = user.delivery_address.state) !== null && _user$delivery_addres !== void 0 && _user$delivery_addres.iso_state ? "-".concat(user.delivery_address.state.iso_state) : "") + " " + ((_listUserGroups$find = listUserGroups.find(function (x) {
                  return x.id === user.user_group.toUpperCase();
                })) === null || _listUserGroups$find === void 0 ? void 0 : _listUserGroups$find.name) + " (" + user.emailAdressToContact + ")";
                _this5.gettingUserList.results.push(_objectSpread(_objectSpread({}, user), {}, {
                  full_name: fullName
                }));
              });
              _this5.gettingUserList.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this5.gettingUserList.isPending = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3);
      }))();
    },
    getConsultantList: function getConsultantList() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _this6$gettingConsult;
        var data, _this, response;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _this6.gettingConsultantList.isPending = true;
              (_this6$gettingConsult = _this6.gettingConsultantList.cancellationToken) === null || _this6$gettingConsult === void 0 || _this6$gettingConsult.cancel();
              _this6.gettingConsultantList.cancellationToken = axios.CancelToken.source();
              data = {
                isConsultant: true,
                active: true
              };
              _this = _this6;
              _context4.next = 7;
              return request("/v1/users", "post", data, true, "api", null, _this.gettingConsultantList.cancellationToken).catch(function (e) {
                if (!axios.isCancel(e)) {
                  var errorData = getErrorData(e, "Unable to get list of available consultants", true);
                  handleErrorData(_this, errorData);
                }
                throw e;
              });
            case 7:
              response = _context4.sent;
              response.data.users.forEach(function (user) {
                _this6.gettingConsultantList.results.push({
                  id: user.id_user,
                  full_name: getFullNameUser(user) + " - " + user.delivery_country_iso_code + " - " + user.consultant_code + " (" + user.login + ")"
                });
              });
              _this6.gettingConsultantList.results.sort(function (a, b) {
                return a.full_name.localeCompare(b.full_name);
              });
              _this6.gettingConsultantList.isPending = false;
            case 11:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }))();
    },
    getCountryList: function getCountryList() {
      var _this7 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _this7.gettingCountryList.isPending = true;
              _this = _this7;
              _context5.next = 4;
              return request("/v1/countries/protected?implantedMarket=true", "GET", null, true, "api").catch(function () {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
                _this.gettingCountryList.isPending = false;
                throw e;
              });
            case 4:
              response = _context5.sent;
              _this7.gettingCountryList.items = _toConsumableArray(response.data.countries);
              _this7.gettingCountryList.isPending = false;
            case 7:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }))();
    },
    getWineList: function getWineList() {
      var _this8 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _this8.gettingWineList.isPending = true;
              _this = _this8;
              _context6.next = 4;
              return request("/v1/wines", "post", {
                paging: null,
                calculate_prices: false,
                only_display_names: true,
                bypassStockSeek: true,
                byPassPagingLimitation: true
              }, true, "api").catch(function () {
                _this.$toasted.show("Unable to load wine list.", {
                  type: "error"
                });
                _this.gettingWineList.isPending = false;
                throw e;
              });
            case 4:
              response = _context6.sent;
              _this8.gettingWineList.items = _toConsumableArray(response.data.wines.map(function (x) {
                return _objectSpread(_objectSpread({}, x), {}, {
                  display_name: x.display_name + (x.accountancy_code ? " - " + x.accountancy_code : "")
                });
              }));
              _this8.gettingWineList.isPending = false;
            case 7:
            case "end":
              return _context6.stop();
          }
        }, _callee6);
      }))();
    },
    getProducerList: function getProducerList() {
      var _this9 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
        var _this, response;
        return _regeneratorRuntime().wrap(function _callee7$(_context7) {
          while (1) switch (_context7.prev = _context7.next) {
            case 0:
              _this9.gettingProducerList.isPending = true;
              _this = _this9;
              _context7.next = 4;
              return request("/v1/producers/all", "post", {}, true, "api").catch(function (_) {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
                _this.gettingProducerList.isPending = false;
                throw e;
              });
            case 4:
              response = _context7.sent;
              _this9.gettingProducerList.items = _toConsumableArray(response.data.value.items);
              _this9.gettingProducerList.isPending = false;
            case 7:
            case "end":
              return _context7.stop();
          }
        }, _callee7);
      }))();
    },
    addCommission: function addCommission() {
      var _this10 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee8$(_context8) {
          while (1) switch (_context8.prev = _context8.next) {
            case 0:
              if (!_this10.validateInputsAddCommission()) {
                _context8.next = 10;
                break;
              }
              _this10.addingCommission.isPending = true;
              _this = _this10;
              _context8.next = 5;
              return request("/v1/commission?isConsultant=" + _this10.isConsultant, "post", _this10.commission, true, "api").catch(function (_) {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
                _this.addingCommission.isPending = false;
                throw e;
              });
            case 5:
              _this10.addingCommission.isPending = false;
              _this10.$toasted.show("Commission successfully added.", {
                type: "success"
              });
              _this10.search();
              _this10.commission = _objectSpread({}, defaultCommissionAddForm);
              _this10.dialogAddCommission = false;
            case 10:
            case "end":
              return _context8.stop();
          }
        }, _callee8);
      }))();
    },
    startEditCommission: function startEditCommission(commissionId) {
      var _item$user, _item$consultant;
      var item = this.gettingCommissionList.items.find(function (x) {
        return x.id_commission === commissionId;
      });
      this.commission = {
        id_commission: item.id_commission,
        percentage_fee: item.percentage_fee,
        user_group: item.user_group,
        userId: ((_item$user = item.user) === null || _item$user === void 0 ? void 0 : _item$user.id_user) > 0 ? item.user.id_user : null,
        consultantId: (_item$consultant = item.consultant) !== null && _item$consultant !== void 0 && _item$consultant.id_user ? item.consultant.id_user : null,
        list_id_countries: item.id_country ? [item.id_country] : [],
        list_id_wineries: item.id_winery && !item.id_wine ? [item.id_winery] : [],
        list_id_wines: item.id_wine ? [item.id_wine] : []
      };
      this.dialogAddCommission = true;
    },
    cancelCommission: function cancelCommission() {
      this.commission = _objectSpread({}, defaultCommissionAddForm);
      this.dialogAddCommission = false;
    },
    validateInputsAddCommission: function validateInputsAddCommission() {
      this.errorLabels = cleanErrors(this.errorLabels);
      if (parseInt(this.commission.percentage_fee) < this.percentageFeeMin || parseInt(this.commission.percentage_fee) > this.percentageFeeMax) {
        this.errorLabels.percentage_fee = this.errorMessages.percentage_fee.value.replace("#min#", this.percentageFeeMin).replace("#max#", this.percentageFeeMax);
      }
      if (this.isUserGroupRequired && !this.commission.user_group) {
        this.errorLabels.user_group = this.errorMessages.mandatory;
      }
      return noErrors(this.errorLabels);
    },
    showConfirmDelete: function showConfirmDelete(id) {
      var _this11 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee9() {
        var _this, confirm;
        return _regeneratorRuntime().wrap(function _callee9$(_context9) {
          while (1) switch (_context9.prev = _context9.next) {
            case 0:
              _this = _this11;
              _context9.next = 3;
              return _this.$refs.confirm.open("Delete", "Are you sure you want to delete this commission ?", {
                color: "red"
              });
            case 3:
              confirm = _context9.sent;
              if (!confirm) {
                _context9.next = 7;
                break;
              }
              _context9.next = 7;
              return _this11.deleteCommission(id);
            case 7:
            case "end":
              return _context9.stop();
          }
        }, _callee9);
      }))();
    },
    deleteCommission: function deleteCommission(id) {
      var _this12 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee10() {
        var _this;
        return _regeneratorRuntime().wrap(function _callee10$(_context10) {
          while (1) switch (_context10.prev = _context10.next) {
            case 0:
              _this = _this12;
              _context10.next = 3;
              return request("/v1/commission/" + id, "delete", null, true, "api").catch(function () {
                _this.$toasted.show("Unable to delete commission.", {
                  type: "error"
                });
                throw e;
              });
            case 3:
              _this12.$toasted.show("Commission deleted.", {
                type: "success"
              });
              _this12.search();
            case 5:
            case "end":
              return _context10.stop();
          }
        }, _callee10);
      }))();
    },
    resetPaging: function resetPaging() {
      this.searchCriterias.paging.askedPage = 0;
    },
    search: function search() {
      var _arguments = arguments,
        _this13 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee11() {
        var isResetPaging, _this, url, response;
        return _regeneratorRuntime().wrap(function _callee11$(_context11) {
          while (1) switch (_context11.prev = _context11.next) {
            case 0:
              isResetPaging = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : false;
              _this = _this13;
              _this.gettingCommissionList.isPending = true;
              if (isResetPaging) _this.resetPaging();
              url = "/v1/commissions";
              if (_this13.target == "consultant") {
                url = "/v1/commissions/consultant";
              }
              _context11.next = 8;
              return request(url, "post", _this.searchCriterias, true, "api").catch(function (_) {
                _this.$toasted.show("An error occured. Please contact an administrator.", {
                  type: "error"
                });
                _this.gettingCommissionList.isPending = false;
                throw e;
              });
            case 8:
              response = _context11.sent;
              _this13.gettingCommissionList.items = _toConsumableArray(response.data.commissions.map(function (commission) {
                var _commission$consultan, _commission$consultan2, _commission$consultan3, _commission$user, _commission$country$p, _commission$country, _commission$winery_na;
                var hasWine = commission.wine.id_wine !== 0;
                var wineDisplayName = hasWine ? commission.wine.display_name : "All";
                var targetIsConsultant = (_commission$consultan = commission.consultant) === null || _commission$consultan === void 0 ? void 0 : _commission$consultan.id_user;
                var targetIsUser = (_commission$consultan2 = commission.consultant) === null || _commission$consultan2 === void 0 ? void 0 : _commission$consultan2.id_user;
                var userGroupLabel = "All";
                if (targetIsConsultant && (_commission$consultan3 = commission.consultant) !== null && _commission$consultan3 !== void 0 && _commission$consultan3.id_user) {
                  userGroupLabel = getFullNameUser(commission.consultant);
                } else if (targetIsUser && (_commission$user = commission.user) !== null && _commission$user !== void 0 && _commission$user.id_user) {
                  userGroupLabel = getFullNameUser(commission.user);
                } else {
                  var group = _this13.derivedUserGroups.find(function (x) {
                    return x.id === commission.user_group;
                  });
                  if (group !== null && group !== void 0 && group.value) {
                    userGroupLabel = group.value;
                  }
                }
                var item = _objectSpread(_objectSpread({}, commission), {}, {
                  fullNameUser: getFullNameUser(commission.user),
                  user_group_label: userGroupLabel,
                  countryName: (_commission$country$p = (_commission$country = commission.country) === null || _commission$country === void 0 ? void 0 : _commission$country.printable_name) !== null && _commission$country$p !== void 0 ? _commission$country$p : "All",
                  wineryName: (_commission$winery_na = commission.winery_name) !== null && _commission$winery_na !== void 0 ? _commission$winery_na : "All",
                  wineName: wineDisplayName
                });
                if (hasWine) {
                  item.wineryName = commission.wine.producer.name;
                  if (commission.hasBeenCreatedForTrumpTaxes202505) {
                    item.wineName += " - TRUMP 2025";
                  }
                }
                return item;
              }));
              _this13.gettingCommissionList.isPending = false;
              _this13.gettingCommissionList.totalNumber = response.data.total_number;
              _this13.gettingCommissionList.numberOfPages = Math.ceil(response.data.total_number / _this.searchCriterias.paging.limits);
              _this13.searchCriterias.paging.currentPage = _this13.searchCriterias.paging.askedPage + 1;
              if (!_this13.searchCriterias.paging.currentPage) {
                _this13.searchCriterias.paging.currentPage = 0;
              }
            case 15:
            case "end":
              return _context11.stop();
          }
        }, _callee11);
      }))();
    },
    openScheduledCommissionsForItem: function openScheduledCommissionsForItem(commissionId) {
      var _item$user2, _item$consultant2;
      var item = this.gettingCommissionList.items.find(function (x) {
        return x.id_commission === commissionId;
      });
      this.scheduledFormValues = {
        futurePercentageFee: item.percentage_fee,
        userGroup: item.user_group,
        userId: (_item$user2 = item.user) === null || _item$user2 === void 0 ? void 0 : _item$user2.id_user,
        consultantId: (_item$consultant2 = item.consultant) === null || _item$consultant2 === void 0 ? void 0 : _item$consultant2.id_user,
        countryIds: item.id_country ? [item.id_country] : [],
        wineryIds: item.id_winery && !item.id_wine ? [item.id_winery] : [],
        wineIds: item.id_wine ? [item.id_wine] : []
      };
      this.openScheduledCommissions();
    },
    openScheduledCommissions: function openScheduledCommissions() {
      var _this14 = this;
      this.isScheduledCommissionsModalShown = true;
      this.$nextTick(function () {
        _this14.$refs.ScheduledCommissionsModal.open();
      });
    },
    closeScheduledCommissions: function closeScheduledCommissions() {
      this.isScheduledCommissionsModalShown = false;
      this.scheduledFormValues = null;
    },
    isAdminNotConsultant: isAdminNotConsultant,
    filterVAutocomplete: filterVAutocomplete
  }
};